import { Component, OnInit } from "@angular/core";
import { CatConceptosService } from "../../servicios/cat-conceptos.service";
import { CatGrupoConceptosService } from "../../servicios/cat-grupo-conceptos.service";
import { CatEstatusService } from "../../servicios/cat-estatus.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { CatConceptos, CatCuentasContables, CatGrupoConceptos, CatEstatus, Privilegios} from "../../entidades/entidades";
import { CatCuentasContablesService } from "../../servicios/cat-cuentas-contables.service";
import { Router } from "@angular/router";
import { PrivilegiosService } from 'app/servicios/privilegios.service';
@Component({
  selector: "app-cat-conceptos-grid",
  templateUrl: "./cat-conceptos-grid.component.html",
  styleUrls: ["./cat-conceptos-grid.component.css"],
})
export class CatConceptosGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catGrupoConceptos: SelectItem[];
  catEstatus: SelectItem[];
  catConceptos: CatConceptos[];
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedCatConceptos: { [s: string]: CatConceptos } = {};
  catCuentasContables: SelectItem[];
  cuentasContablesCargo: SelectItem[];
  cuentasContablesAbono: SelectItem[];
  cuentasContablesEjecutar: SelectItem[];
  cuentasContablesDevengado: SelectItem[];
  cuentasContableRecaudado: SelectItem[];
  privilegios: boolean = false;


  constructor(
   private catConceptosService: CatConceptosService,
    private catGrupoConceptosService: CatGrupoConceptosService,
    private catEstatusService: CatEstatusService,
    private router: Router,
    private privilegiosService: PrivilegiosService,
    private catCuentasContablesService: CatCuentasContablesService,
  ) {}

  async ngOnInit() {
    await this.getAllCatGrupoConceptos();
    await this.getAllCatEstatus();
    await this.getAllCatConceptos();
    await this.getAllCatCuentasContables();
    await this.getPrivilegios();

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [ 
      {label: "Guardar",   icon: "pi pi-save",    command: (event) => {this.guardarGridCatConceptos();} },
      {label: "Refrescar", icon: "pi pi-refresh", command: (event) => {this.getAllCatConceptos();} },
    ];

    if(this.privilegios)
      this.itemsMenu.unshift({label: "Agregar",   icon: "pi pi-file-o",  command: () => this.add(), });

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "operacion",header: "Editar", ordenar: false, styleHeader: "width: 50px;"},
     /*  {field: "id", header: "Id",ordenar: false, styleHeader: "width: 30px;",}, */
      {field: "descripcion", header: "Descripcion",ordenar: true, styleHeader: "width: 150px;",},
     // {field: "cuentaContable", header: "Cuenta Contable",ordenar: true, styleHeader: "width: 150px;",},
      { field: "calcIva", header: "Iva", ordenar: true, styleHeader: "width:150px;",},
      {field: "idGrupoConcepto", header: "Grupo Concepto",ordenar: true, styleHeader: "width: 200px;",},
      {field: "idEstatus", header: "Estatus",ordenar: true, styleHeader: "width: 200px;",},
      {field: "observaciones", header: "Observaciones",ordenar: true, styleHeader: "width: 150px;",},
      {field: "solicitable", header: "Solicitable",ordenar: true, styleHeader: "width: 150px;",},
      {field: "fechaIni", header: "Fecha Ini",ordenar: true, styleHeader: "width: 150px;",},
      {field: "fechaFin", header: "Fecha Fin",ordenar: true, styleHeader: "width: 150px;",},
      {field: "orden", header: "Orden",ordenar: true, styleHeader: "width: 150px;",},
      {field: "idCuentaCargo", header: "Cuenta Cargo",ordenar: true, styleHeader: "width: 460px;",},
      {field: "idCuentaAbono", header: "Cuenta Abono",ordenar: true, styleHeader: "width: 460px;",},
      {field: "idCuentaEjecutar", header: "Cuenta Ejecutar",ordenar: true, styleHeader: "width: 460px;",},
      {field: "idCuentaDevengado", header: "Cuenta Devengado",ordenar: true, styleHeader: "width: 460px;",},
      {field: "idCuentaRecaudado", header: "Cuenta Recaudado",ordenar: true, styleHeader: "width: 460px;",},
      
     // {field: "acciones", header: "Eliminar",ordenar: false, styleHeader: "width: 50px;",},
     
    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    let catConceptosNew = new CatConceptos();
    catConceptosNew.cambio = true;
    catConceptosNew.id = 0;
    catConceptosNew.numRow = this.catConceptos.length + 1;
    this.catConceptos.unshift(catConceptosNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let catConceptosEdit = event.data;
    this.clonedCatConceptos[catConceptosEdit.numRow] = { ...catConceptosEdit };
    catConceptosEdit.cambio = true;
    catConceptosEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let catConceptosEdit = event.data;
    let index = this.catConceptos.findIndex(
      (obj) => obj.numRow === catConceptosEdit.numRow
    );
    this.catConceptos[index] = { ...this.clonedCatConceptos[catConceptosEdit.numRow]};
  }

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let catConceptosEdit = event.data;

      //Valida si hay cambios
      if (
        catConceptosEdit.id === this.clonedCatConceptos[catConceptosEdit.numRow].id &&
        catConceptosEdit.descripcion === this.clonedCatConceptos[catConceptosEdit.numRow].descripcion &&
        //catConceptosEdit.cuentaContable === this.clonedCatConceptos[catConceptosEdit.numRow].cuentaContable &&
        catConceptosEdit.calcIva === this.clonedCatConceptos[catConceptosEdit.numRow].calcIva &&
        catConceptosEdit.idGrupoConcepto === this.clonedCatConceptos[catConceptosEdit.numRow].idGrupoConcepto &&
        catConceptosEdit.idEstatus === this.clonedCatConceptos[catConceptosEdit.numRow].idEstatus &&
        catConceptosEdit.observaciones === this.clonedCatConceptos[catConceptosEdit.numRow].observaciones &&
        catConceptosEdit.solicitable === this.clonedCatConceptos[catConceptosEdit.numRow].solicitable &&
        catConceptosEdit.fechaIni === this.clonedCatConceptos[catConceptosEdit.numRow].fechaIni &&
        catConceptosEdit.fechaFin === this.clonedCatConceptos[catConceptosEdit.numRow].fechaFin &&
        catConceptosEdit.orden === this.clonedCatConceptos[catConceptosEdit.numRow].orden &&
        catConceptosEdit.idCuentaCargo === this.clonedCatConceptos[catConceptosEdit.numRow].idCuentaCargo &&
        catConceptosEdit.idCuentaAbono === this.clonedCatConceptos[catConceptosEdit.numRow].idCuentaAbono && 
        catConceptosEdit.idCuentaEjecutar === this.clonedCatConceptos[catConceptosEdit.numRow].idCuentaEjecutar &&
        catConceptosEdit.idCuentaDevengado === this.clonedCatConceptos[catConceptosEdit.numRow].idCuentaDevengado &&
        catConceptosEdit.idCuentaRecaudado === this.clonedCatConceptos[catConceptosEdit.numRow].idCuentaRecaudado
      ) {
        let index = this.catConceptos.findIndex((obj) => obj.numRow === catConceptosEdit.numRow);
        this.catConceptos[index] = {...this.clonedCatConceptos[catConceptosEdit.numRow]};
        return;
      }

      //Validaciones
      //throw new Error("No paso las validaciones.");

      catConceptosEdit.cambio = true;
      catConceptosEdit.baja = false;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridCatConceptos() {
    try {
      for (let catConceptosFor of this.catConceptos) {
        if (catConceptosFor.baja) {
          await this.deleteCatConceptos(catConceptosFor);
        } else if (catConceptosFor.cambio) {
          catConceptosFor.cambio = false;
          this.clonedCatConceptos[catConceptosFor.id] = { ...catConceptosFor, };
          if (catConceptosFor.id === 0) {
            const datoRetorno = await this.addCatConceptos(catConceptosFor);
            catConceptosFor.id = datoRetorno.id;
          } else {
            await this.updateCatConceptos(catConceptosFor);
          }
        }
      }

      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCatConceptos");
    }
  }

  // prettier-ignore
  async addCatConceptos(catConceptos) {
    try {
      const datoretorno = await this.catConceptosService
        .add(catConceptos)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCatConceptos");
    }
  }

  // prettier-ignore
  async getAllCatConceptos() {
    try {
      const datoRetorno = await this.catConceptosService.getAll().toPromise();
      for (var i = 0, len = datoRetorno.length; i < len; ++i){
        datoRetorno[i].fechaIni = new Date(datoRetorno[i].fechaIni);
        datoRetorno[i].fechaFin = new Date(datoRetorno[i].fechaFin);
      }
      this.catConceptos = datoRetorno;
      for (var i = 0, len = this.catConceptos.length; i < len; ++i){
        this.catConceptos[i].numRow = i;
        this.clonedCatConceptos[this.catConceptos[i].numRow] = {...this.catConceptos[i],        };
      } 
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatConceptos");
    }
  }

  // prettier-ignore
  async updateCatConceptos(catConceptos: CatConceptos) {
    try {
      const datoRetorno = await this.catConceptosService
        .update(catConceptos)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCatConceptos");
    }
  }

  // prettier-ignore
  async deleteCatConceptos(catConceptos: CatConceptos) {
    try {
      const datoRetorno = await this.catConceptosService
        .delete(catConceptos.id)
        .toPromise();
      this.getAllCatConceptos();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteCatConceptos");
    }
  }

  // prettier-ignore
  async getAllCatGrupoConceptos() {
    try {
      const datoRetorno = await this.catGrupoConceptosService.getAll().toPromise();
      this.catGrupoConceptos = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catGrupoConceptos.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatGrupoConceptos");
    }
  }

  // prettier-ignore
  async getAllCatEstatus() {
    try {
      const datoRetorno = await this.catEstatusService.getAll().toPromise();
      this.catEstatus = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catEstatus.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatEstatus");
    }
  }

  async getAllCatCuentasContables() {
    try {
      debugger;
      console.log("inicia getCatCuentasContables");

      const datoRetorno = await this.catCuentasContablesService.getAll().toPromise();
      console.log("api",datoRetorno);

      this.cuentasContablesAbono = datoRetorno.map((datos) => {
        if(datos.idTipoCuentaContable === 2){
          const labe = `${datos.cuentaCargo}-${datos.descripcion.substring(0, 30)}`;
          return { label: labe, value: datos.id };
        }else{
          return null;
        }
      }).filter((item) => item !== null);

      this.cuentasContablesCargo = datoRetorno.map((valor) =>{
        if(valor.idTipoCuentaContable === 1){
          const label = `${valor.cuentaCargo}-${valor.descripcion.substring(0, 30)}`;
          return {label: label, value: valor.id};
        }else{
          return null;
        }
      }).filter((item) => item !== null);
    
      //EJECUTAR	3
      this.cuentasContablesEjecutar= datoRetorno.map((valor) =>{
        if(valor.idTipoCuentaContable === 3){
          const label = `${valor.cuentaCargo}-${valor.descripcion.substring(0, 30)}`;
          return {label: label, value: valor.id};
        }else{
          return null;
        }
      }).filter((item) => item !== null);
    
      //DEVENGADO	4
      this.cuentasContablesDevengado= datoRetorno.map((valor) =>{
        if(valor.idTipoCuentaContable === 4){
          const label = `${valor.cuentaCargo}-${valor.descripcion.substring(0, 30)}`;
          return {label: label, value: valor.id};
        }else{
          return null;
        }
      }).filter((item) => item !== null);
    //RECAUDADO	5
     this.cuentasContableRecaudado=datoRetorno.map((valor) =>{
      if(valor.idTipoCuentaContable === 5){
        const label = `${valor.cuentaCargo}-${valor.descripcion.substring(0, 30)}`;
        return {label: label, value: valor.id};
      }else{
        return null;
      }
    }).filter((item) => item !== null);



      this.cuentasContablesCargo.unshift({ label: "Todos", value: null });
      this.cuentasContablesAbono.unshift({ label: "Todos", value: null});
      this.cuentasContablesEjecutar.unshift({ label: "Todos", value: null });
      this.cuentasContablesDevengado.unshift({ label: "Todos", value: null });
      this.cuentasContableRecaudado.unshift({ label: "Todos", value: null });

      //this.catCuentasContables = datoRetorno;
      console.log("termina getCatCuentasContables",this.catCuentasContables);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatCuentasContables");
    }
  }

    async getPrivilegios() {
      try {
  
        let objUrl = new Privilegios();
        objUrl.descripcion = this.router.url + '/consulta_edicion';
        let consultaRemesa = await this.privilegiosService.GetPrivilegioByRoute(objUrl).toPromise();
        this.privilegios = consultaRemesa ? true : false; 
      } catch (e) {
        if (e.response) throw { message: e.response.data };
        else throw e;
      } finally {
        console.log("Paso por getPrivilegios");
      }
    }
}